<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(patient)="data">
               <b>  {{ data.item.appuser.name }}</b><br>
               <small>{{ data.item.appuser.contact }}</small><br>
               <small>{{ data.item.appuser.address }}</small>
                </template>
                <template #cell(product)="data">
                  {{ data.item.product.name }}
                </template>
                <template #cell(unit)="data">
                  {{ data.item.unit.unit_name }}
                </template>
                              
               
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <span v-if="data.item.status == 1">
                     <b-button @click="edit(data.item.id,data.item.qty_delievered,data.item.qty_ordered)" type="button" class="btn-sm btn" variant="danger" v-b-modal.edit> <i class="mdi mdi-approve"></i>Pending</b-button>
                    </span>
                    <span v-else>
                     <b-button   type="button" class="btn-sm btn" variant="primary"> <i class="mdi mdi-approve"></i>Confrimed</b-button>
                    </span> 
                   
                </div>
                </template>
                </b-table>
                <div class="mt-3">
                <strong>Total: {{commas (totalcost) }}</strong>
              </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      
  
      <b-modal id="edit-item" centered title="Approve Appointment " title-class="font-14" hide-footer>
          <form @submit.prevent="approve">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
             <label> Quantity to be Delievered</label>
                <input v-model="qty_delievered" type="number" class="form-control" :min="0"/>
                <!-- <input v-model="qty_ordered" type="number" class="form-control" /> -->

            </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-item')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
        
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import {  drugsComputed,drugsMethods} from "@/state/helpers";
  
  export default {
    page: {
      title: "Drug Orders",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader

    },
    data() {
      return {
        title: "Drug Order",
        items: [ {text: "Dashboard",to: "/",}, {text: "Drug Orders",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'patient', label: 'Patient', visible: true },
            { key: 'product', label: 'Product', visible: true },
            { key: 'qty_ordered', label: 'Ordered', visible: true },
            { key: 'qty_delievered', label:'Delivered', visible:true},
            { key: 'unit', label: 'Unit', visible: true },
            { key: 'total', label: 'Total', visible: true },
            { key: 'actions', label: 'Status', visible: true },
          ],
        id:'',
        qty_delievered:'',
        // qty_ordered:'',
      };
    },
    computed: {
      ...drugsComputed,
      List() { return this.drugs.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.drugs.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.drugs.length>0) { a=false;} else { a=true;} return a },
      totalcost() {return this.Items.reduce((total, item) => total + parseFloat(item.total), 0);},

    },
    mounted() {
      this.fetchDrugs();   
      this.TotalRows = this.drugs.length;
      this.isBusy=false;
    },
    methods: {
      ...drugsMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      commas(x) { return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

      edit(id,qty_delievered,qty_ordered){
        this.id=id;
        this.qty_delievered = qty_delievered || qty_ordered; 
        // this.qty_delievered=qty_delievered;
        this.qty_ordered=qty_ordered;
        this.$bvModal.show('edit-item')
      },
     
      async approve() { 
        let formData = new FormData();
        formData.append("id", this.id);
        formData.append("qty_delievered", this.qty_delievered);
        
        let url = "adddrug";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchDrugs();
            this.$bvModal.hide('edit-item');
            this.qty_delievered="";
           
        }
        });
      },
     
    },
  };
  </script>